const alert = (state = { title: '', description: '', okTitle: '', cancelTitle: null, onCancel: null, type: '', open: false, onOk: null, disableClose: false }, action) =>
{
	switch (action.type)
	{
		case 'SET_ALERT':
		{
			const { title, description, okTitle, cancelTitle, type, onOk, onCancel, disableClose } = action.payload;

			return { ...state, title, description, okTitle, cancelTitle, type, open: true, onOk, onCancel, disableClose };
		}

		case 'CLOSE_ALERT':
		{
			return { ...state, title: '', description: '', okTitle: '', cancelTitle: null, type: '', open: false, onCancel: null, onOk: null, disableClose: false };
		}

		default:
			return state;
	}
};

export default alert;
